import React from "react";
import { Card, Button, ButtonProps } from "react-bootstrap";
import styled from "styled-components";

const StyledCard = styled(Card)`
  text-align: center;
  margin: 2rem 0;
  background-color: #f8f9fa;
  border: none;
  width: 100%;
`;

const StyledButton = styled(Button).attrs({
  variant: "primary",
})<ButtonProps>`
  background-color: var(--primary-bg);
  border-color: var(--primary-bg);
  &:hover,
  &:focus,
  &:active {
    background-color: var(--primary-bg) !important;
    border-color: var(--primary-bg) !important;
    opacity: 0.9;
  }
`;

const ContactSupport: React.FC = () => {
  const handleContactSupport = () => {
    window.location.href = "mailto:support@qrsharp.com";
  };

  return (
    <StyledCard>
      <Card.Body className="py-5">
        <h4 className="mb-3">Can't find what you're looking for?</h4>
        <p className="text-muted mb-4">
          Our support team is here to help with any questions you may have.
        </p>
        <StyledButton size="lg" onClick={handleContactSupport}>
          Contact Support
        </StyledButton>
      </Card.Body>
    </StyledCard>
  );
};

export default ContactSupport;
